































import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import { StickyType } from '@spa/components/organisms/sticky/model/Types'
import Sticky from '@spa/components/organisms/sticky/Sticky.vue'

@Component({
  components: {
    Sticky,
  },
})
export default class SearchContactLensFilterButton extends Vue {
  stickyTypeTop = StickyType.TOP
}
